import studentRoutes from "./student.routes";
import teacherRoutes from "./teacher.routes";

const routes = [...teacherRoutes, ...studentRoutes];

export default routes;

export * from "./routeNames";
